"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import ReactUtils from "../../react_utils";
import Api from "../../api/api";
const bem = ReactUtils.makeBem("document-browser");
function customerLoadMetadata(tmsCustomerLoad) {
  let customerNameText = "";
  if (!_.isEmpty(tmsCustomerLoad.tms_customer)) {
    customerNameText = " for " + tmsCustomerLoad.tms_customer.name;
  }
  const accountSettings = Api.Account.currentSettings();
  let refValue;
  if (accountSettings.primary_shipment_reference_label) {
    refValue = tmsCustomerLoad.references[accountSettings.primary_shipment_reference_label];
  } else {
    refValue = tmsCustomerLoad.customer_load_id;
  }
  return refValue + customerNameText;
}
function hasAnyOtherDocumentsFromLoad(props, tmsCustomerLoad, documentId) {
  return _.any(
    tmsCustomerLoad.documents,
    (document) => document.id !== documentId && props.allDocumentIds.includes(document.id)
  );
}
function customerLoad(props, tmsCustomerLoad, i) {
  const documentId = props.document.id;
  const isChecked = _.some(
    tmsCustomerLoad.documents,
    (document) => document.id === documentId
  );
  const isDisabled = !isChecked && hasAnyOtherDocumentsFromLoad(props, tmsCustomerLoad, documentId);
  const onChange = _.partial(
    props.toggleCustomerLoadDocument,
    tmsCustomerLoad,
    props.document
  );
  const cssClasses = bem({
    "__assign-documents-selector-label": true,
    "__assign-documents-selector-item-label--disabled": isDisabled
  });
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("label", { className: cssClasses, children: [
    /* @__PURE__ */ jsxs("span", { children: [
      i + 1 + ")",
      "\xA0"
    ] }),
    /* @__PURE__ */ jsx(
      "input",
      {
        className: bem("__assign-documents-selector-checkbox"),
        checked: isChecked,
        onChange,
        type: "checkbox"
      }
    ),
    /* @__PURE__ */ jsxs("span", { children: [
      "\xA0",
      customerLoadMetadata(tmsCustomerLoad)
    ] })
  ] }) }, "customer-load-" + i);
}
export default function CustomerLoadSelector(props) {
  return /* @__PURE__ */ jsxs("div", { className: bem("__assign-documents-selector"), children: [
    "Choose the customer load this document is for:",
    _.map(
      props.tmsCustomerLoads,
      (tmsCustomerLoad, i) => customerLoad(props, tmsCustomerLoad, i)
    )
  ] });
}
